import { CustomerVehicle } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { WorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { WorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { Form, Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { useEffect } from 'react';

interface Props {
  workorderData?: WorkOrder;
  vehicleData?: CustomerVehicle;
  complement?: WorkOrderComplement;
}
const MechanicsRecordVehicleInfo: React.FC<Props> = ({
  workorderData,
  vehicleData,
  complement,
}) => {
  const [form] = Form.useForm();
  const vehicleName = Form.useWatch('vehicleName', form);

  const row = vehicleName?.length > 53 ? 2 : 1;

  useEffect(() => {
    if (!!vehicleData) {
      form.setFieldsValue({
        vehicleName: `${vehicleData.model.brand.name || ''} ${
          vehicleData.model.name || ''
        }`,
        licensePlate: vehicleData.licensePlate,
        chassi: vehicleData.chassi,
        model: `${vehicleData.yearFabrication}/${vehicleData.yearModel}`,
      });
    }

    if (!!complement) {
      form.setFieldsValue({
        prisma: complement.prisma,
        estimatorName: complement.estimator.name,
        km: complement.currentKilometers,
      });
    }
  }, [vehicleData, complement]);

  return (
    <Form form={form}>
      <table className="vehicle-info">
        <thead>
          <tr>
            <th>O.S Nº</th>
            <th>Veículo</th>
            <th>Placa</th>
            <th>Chassi</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>{workorderData?.number}</td>

            <td>
              <Form.Item noStyle name="vehicleName">
                <TextArea rows={row} />
              </Form.Item>
            </td>

            <td>
              <Form.Item noStyle name="licensePlate">
                <TextArea rows={row} />
              </Form.Item>
            </td>

            <td>
              <Form.Item noStyle name="chassi">
                <TextArea rows={row} />
              </Form.Item>
            </td>
          </tr>
        </tbody>
      </table>

      <table className="vehicle-verification">
        <thead>
          <tr>
            <th>Prisma</th>
            <th>Fab./Modelo</th>
            <th>KM</th>
            <th>Conf. Chassi</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <Form.Item noStyle name="prisma">
                <TextArea rows={1} />
              </Form.Item>
            </td>

            <th>
              <Form.Item noStyle name="model">
                <TextArea rows={1} />
              </Form.Item>
            </th>

            <td>
              <Form.Item noStyle name="km">
                <Input type="number" />
              </Form.Item>
            </td>

            <td>
              <TextArea rows={1} />
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ marginBottom: 12 }}>
        <thead>
          <tr>
            <th>Mecânico</th>
            <th>Líder</th>
            <th>Consultor</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            {Array.from({ length: 2 }).map((_, index) => (
              <td key={index}>
                <TextArea rows={1} />
              </td>
            ))}

            <td>
              <Form.Item noStyle name="estimatorName">
                <TextArea rows={1} />
              </Form.Item>
            </td>
          </tr>
        </tbody>
      </table>
    </Form>
  );
};

export default MechanicsRecordVehicleInfo;
